import { commonRowAndCellClassRules } from '_legacy/components/grid/classRules/classRules';
import allowUpAndDownOnEdit from '_legacy/components/grid/columnDefaults/allowUpAndDownOnEdit';
import defaultSetFilterParams from '_legacy/components/grid/columnDefaults/defaultSetFilterParams';
import naturalSortComparator from '_legacy/components/grid/comparators/NaturalSortComparator';
import SelectEditor from '_legacy/modules/shared/columns/editors/SelectEditor';
import { isEditableRow } from '_legacy/modules/shared/columns/tools/headingTools';

export const getChartererTypes = () => {
    return ['', 'Majors', 'Projects', 'Utilities', 'Trader', 'Undedicated'];
};

const chartererTypeHeading = {
    colId: 'chartererType',
    headerName: 'Charterer Type',
    field: 'chartererType',
    editable: isEditableRow,
    cellEditorFramework: SelectEditor,
    hide: true,
    cellEditorParams: {
        valuesByDataset: getChartererTypes,
    },
    suppressKeyboardEvent: allowUpAndDownOnEdit(),
    width: 120,
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        comparator: naturalSortComparator,
    },
};

export default chartererTypeHeading;
